/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ErrorCodeDto,
    ErrorCodeDtoFromJSON,
    ErrorCodeDtoFromJSONTyped,
    ErrorCodeDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface TranslationCodesVm
 */
export interface TranslationCodesVm {
    /**
     * 
     * @type {Array<ErrorCodeDto>}
     * @memberof TranslationCodesVm
     */
    errors?: Array<ErrorCodeDto> | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof TranslationCodesVm
     */
    enums?: { [key: string]: Array<string>; } | null;
}

export function TranslationCodesVmFromJSON(json: any): TranslationCodesVm {
    return TranslationCodesVmFromJSONTyped(json, false);
}

export function TranslationCodesVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationCodesVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(ErrorCodeDtoFromJSON)),
        'enums': !exists(json, 'enums') ? undefined : json['enums'],
    };
}

export function TranslationCodesVmToJSON(value?: TranslationCodesVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(ErrorCodeDtoToJSON)),
        'enums': value.enums,
    };
}


